import { Injectable } from '@angular/core';
import { UserService } from '../user/user.service';
import { PreferencesService } from '../preferences/preferences.service';
import { HttpClient } from '@angular/common/http';
import { AppUser, ServerLicenzeSdtResponse } from 'src/app/common/models/Utente';
import { Observable, lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(
    private http: HttpClient,
    private userService: UserService,
    private preferenzeService: PreferencesService) { }

  /**
   * Tenta ti loggarsi al backend. 
   * Come effetto collaterale: 
   * - aggiorna le preferenze applicative associate all'utente giunte
   * nel parametro "configurazioneDinamica"
   * - aggiorna il flag di connettivita' di network service ad online
   * @param alias 
   * @param serverIp 
   * @param username 
   * @param password 
   * @returns struttura dati con tutti i dati utente
   * @throws un errore se il login fallisce per qualche motivo (stato non 200) che
   * e' imputabile ad un errore di autenticazione o di comunicazione con il server
   */
  async login(alias: string, serverIp: string, username: string, password: string): Promise<AppUser> {
    try {
      const appUser = await this.loginHttpLogic(serverIp, username, password);
      const stResponse = appUser['st'];
      if (stResponse !=0) {
        throw Error(this.loginErrorMessage(stResponse));
      }
      appUser.password = password;
      appUser.putSigla = username;
      appUser.server = serverIp;
      appUser.alias = alias;
      await this.userService.setDatiUtente(appUser);
      const config = appUser.configurazioneDinamica;
      await this.preferenzeService.settaConfigurazioneDaLogin(config);
      return appUser;
    } catch (loginError) {
      console.error('Login error: ', loginError);
      throw loginError;
    }
  }

  private async loginHttpLogic(serverIp: string, username: string, password: string): Promise<AppUser> {
    const completeLoginUrl = `${serverIp}/immto_wsr_login`;

    return lastValueFrom(this.http.post<AppUser>(completeLoginUrl, {
      username, password
    }))
  }

  async logout() {
    // Invalidare dati
    console.warn('LOGOUT auth service non supportato');
    await this.userService.logout();
  }

  /**
   * Cerca di rieseguire il login con i dati username, password e ip immessi 
   * precedentemente 
   */
  async refreshToken(): Promise<AppUser> {
    // Aggiornare token memorizzato
    const userData = await this.userService.getDatiUtente();
    return await this.login(userData.alias, userData.server, userData.putSigla, userData.password);
  }

  getUrls(username: string, password: string, alias: string): Observable<ServerLicenzeSdtResponse>{
    return this.getUrlsFromServerLicenze(username,password,alias)
  }

  private getUrlsFromServerLicenze(username: string, password: string, alias: string): Observable<ServerLicenzeSdtResponse> {
  // - DOC --> App Documentale
	// - ASS --> App Asset
	// - OEN --> App Order Entry
	// - SER --> App Service
	// - INV --> App Inventario
	// - PCK --> App Packing
    const actionUrl = `https://licintegra.agomir.com:443/srvlic/rest/imsrvlicurlws` //url fisso server delle licenze
        const params = {
          alias: alias,
          tpapp: 'SER',
          user: username,
          password: password,
        }
    return this.http.post<ServerLicenzeSdtResponse>(actionUrl, params);
  }

  private loginErrorMessage(st: number){
    switch(st){
      case 7:
        return "Modulo non abilitato";
      case 8:
        return "Password scaduta";
      case 9:
        return "Errore di autenticazione";
      default:
        return "Errore non definito (stato != da 7,8,9)";
    }
  }
}